// @flow

export function getBuildNumber(): number | string {
  // défini par `npm run build` ; fallback pour `npm start`, le .env n'étant plus versionné
  // $FlowFixMe
  return process.env.REACT_APP_BUILD_TIME || 1;
}